import { useMemo, useState } from 'react';

const normalizar = (valor) => String(valor ?? '').toLowerCase();

/**
 * Búsqueda de texto libre 100% cliente (HU-014) — para las pantallas que ya
 * traen su lista completa de una sola llamada y usan `usePaginacionLocal`
 * (Usuarios, Roles, Categorías; Vías queda afuera porque ya busca contra el
 * backend). Sin esto, cada pantalla repetiría su propio estado y su propio
 * `.filter()`. `extraerTexto(item)` arma el string donde se busca (ej.
 * nombre + documento + email de un usuario) — cada pantalla decide qué
 * campos son relevantes para su propia búsqueda.
 */
const useFiltroBusqueda = (items, extraerTexto) => {
  const [busqueda, setBusqueda] = useState('');

  const itemsFiltrados = useMemo(() => {
    const texto = normalizar(busqueda).trim();
    if (!texto) return items;
    return items.filter((item) => normalizar(extraerTexto(item)).includes(texto));
  }, [items, busqueda, extraerTexto]);

  return { busqueda, setBusqueda, itemsFiltrados };
};

export default useFiltroBusqueda;
